const blogs = (() =>{
    
    const initBlock = el => {        
        const filtersWrapper = el.querySelector('[data-blogs-filters]');
        filtersWrapper.querySelectorAll('[name="category"]').forEach(cb => {
            cb.addEventListener('click', () => {
                handleFilter(el, "1");
            });
        });
        const searchInput = filtersWrapper.querySelector('input[name="searchTerm"]');
        const searchButton = filtersWrapper.querySelector('button[data-search]');
        if (searchInput && searchButton){
            searchButton.addEventListener('click', () => {
               handleFilter(el, "1"); 
            });
            searchInput.addEventListener('keyup', (e) => {
               e.preventDefault();
               if (e.keyCode === 13) handleFilter(el, "1");
            });
        }
        paging.handlePaging(el, handleFilter);
    };
    
    const handleFilter = (el, pageId) => {
        const filtersWrapper = el.querySelector('[data-blogs-filters]');
        const nodeId = filtersWrapper.dataset.nodeid;
        const pageSize = filtersWrapper.dataset.pagesize;
        const searchTerm = filtersWrapper.querySelector('input[name="searchTerm"]').value;
        let filters = [];
        filtersWrapper.querySelectorAll('[name="category"]').forEach(cb => {
            if (cb.checked) {
                filters.push(cb.value);
            }
        });
        let resultsWrapper = el.querySelector('[data-blogs-results]');
        fetch(`/umbraco/surface/blogs/get?nodeId=${nodeId}&filters=${filters}&searchTerm=${searchTerm}&pageSize=${pageSize}&pageId=${pageId}`)
            .then(response => response.text())
            .then(data => {
                if (resultsWrapper && data){
                    resultsWrapper.outerHTML = data;
                    resultsWrapper = el.querySelector('[data-blogs-results]');
                    paging.handlePaging(el, handleFilter);
                }
            })
            .catch(_ => {});
    };
    return {initBlock};
})();
document.querySelectorAll('[data-blogs]').forEach(el => blogs.initBlock(el));
